/** @format */
import { Graph } from '@antv/x6'

// 各个类型的节点和边的默认属性
export const specialAttrs = {
  nodes: {
    START: {
      body: {
        rx: 6,
        ry: 6
      }
    },
    AUTOTASK_DISPLAY: {
      body: {
        refPoints: '10,0 40,0 30,20 0,20',
        stroke: '#f9b264',
        fill: '#fec990'
      }
    },
    GATEWAY: {
      body: {
        refPoints: '0,10 10,0 20,10 10,20'
      }
    },
    AUTOTASK_SUBSCENE: {
      body: {
        rx: 0,
        ry: 0,
        stroke: '#c7f2e1',
        fill: '#a3f7d6'
      },
      labelStyle: {
        fontSize: 12,
        fill: '#262626'
      }
    },
    AUTOTASK_TIMER: {
      body: {
        width: 100,
        height: 100
      }
    },
    PARALLEL_GATEWAY: {
      body: {
        refPoints: '0,10 10,0 20,10 10,20',
        stroke: '#c7f2e1',
        fill: '#a3f7f3'
      }
    },
    END: {
      body: {
        rx: 6,
        ry: 6
      }
    },
    USERTASK: {
      body: {
        refPoints: '10,0 40,0 30,20 0,20',
        stroke: '#b7eb8f',
        fill: '#f6ffed'
      }
    }
  },
  edges: {
    wrap: {
      strokeWidth: 2
    },
    line: {
      stroke: '#A2B1C3',
      targetMarker: { height: 8, name: 'block', width: 12 },
      selectable: true
    }
  }
}

const groups = {
  top: {
    position: 'top',
    attrs: {
      circle: {
        r: 4,
        magnet: true,
        stroke: '#5F95FF',
        strokeWidth: 1,
        fill: '#fff',
        style: {
          visibility: 'hidden'
        }
      }
    }
  },
  right: {
    position: 'right',
    attrs: {
      circle: {
        r: 4,
        magnet: true,
        stroke: '#5F95FF',
        strokeWidth: 1,
        fill: '#fff',
        style: {
          visibility: 'hidden'
        }
      }
    }
  },
  bottom: {
    position: 'bottom',
    attrs: {
      circle: {
        r: 4,
        magnet: true,
        stroke: '#5F95FF',
        strokeWidth: 1,
        fill: '#fff',
        style: {
          visibility: 'hidden'
        }
      }
    }
  },
  left: {
    position: 'left',
    attrs: {
      circle: {
        r: 4,
        magnet: true,
        stroke: '#5F95FF',
        strokeWidth: 1,
        fill: '#fff',
        style: {
          visibility: 'hidden'
        }
      }
    }
  }
}
export const ports = {
  groups: groups,
  items: [
    {
      group: 'top'
    },
    {
      group: 'right'
    },
    {
      group: 'bottom'
    },
    {
      group: 'left'
    }
  ]
}
export const polygonPorts = {
  groups: groups,
  items: [
    {
      group: 'top'
    },
    {
      group: 'right',
      args: {
        dx: -12
      }
    },
    {
      group: 'bottom'
    },
    {
      group: 'left',
      args: {
        dx: 12
      }
    }
  ]
}

// 跟踪节点注册状态，避免重复注册
let nodesRegistered = false

export const registerNode = () => {
  // 如果已经注册过，直接返回，避免覆盖
  if (nodesRegistered) {
    return
  }

  Graph.registerNode(
    'custom-rect',
    {
      inherit: 'rect',
      width: 100,
      height: 36,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: 'rgba(126, 193, 255, 1)',
          fill: 'rgba(126, 193, 255, 0.46)'
        },
        label: {
          fontSize: 12,
          fill: '#262626',
          textWrap: { width: -50, ellipsis: true, breakWord: true }
        }
      },
      ports: { ...ports }
    },
    true
  )

  Graph.registerNode(
    'custom-polygon',
    {
      inherit: 'polygon',
      width: 100,
      height: 36,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#f5dbbe',
          fill: '#fee7ce'
        },
        text: {
          fontSize: 12,
          fill: '#262626',
          textWrap: { width: -50, ellipsis: true, breakWord: true }
        }
      },
      ports: {
        ...polygonPorts
      }
    },
    true
  )

  Graph.registerNode(
    'custom-circle',
    {
      inherit: 'circle',
      width: 50,
      height: 50,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF'
        },
        text: {
          fontSize: 12,
          fill: '#262626',
          textWrap: { ellipsis: true, breakWord: true }
        }
      },
      ports: { ...ports }
    },
    true
  )

  nodesRegistered = true
}
